import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { setToken, clearToken } from "../utils/auth";

const ProtectedRoute = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const [authed, setAuthed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const idToken = await user.getIdToken();
        setToken(idToken);
        setAuthed(true);
      } else {
        clearToken();
        setAuthed(false);
      }
      setChecking(false);
      try { window.dispatchEvent(new Event("authChanged")); } catch (e) {}
    });
    return () => unsub();
  }, []);

  if (checking) return null;
  if (!authed) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
};

export default ProtectedRoute;
